import { openAPIClient } from '../openApiClient';
import type {
  DuplicateContentResponse,
  DuplicateContentServiceConfig,
} from './types/index';

export async function duplicateContentService({
  httpRequestConfig,
  params,
}: DuplicateContentServiceConfig): Promise<DuplicateContentResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/admin/duplicateContent', {
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
